'use client';

import dynamic from 'next/dynamic';

const Swap = dynamic(async () => import('@/components/Swap/Swap'), {
  ssr: false, // This will disable server-side rendering for this component
});

export default function SwapPage() {
  return <Swap />;
}
